import { useState, useRef } from 'react'
import { Input } from "components/forms";
import State from "components/tracking/State/State";
import { Button, Card, Timeline } from "components/ui";
import { isEmpty } from '../src/helpers/helpers'
import deliveryBox from 'assets/images/delivery-box.png'

const publicUrl = process.env.REACT_APP_PUBLIC_URL;
const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;

function App() {

	const [trackingState, setTrackingState] = useState();
	const [trackingOrder, setTrackingOrder] = useState();
	
	const trackingCodeInput = useRef();

	const getTrackingOrder = async () => {
		

		const codeNumber = trackingCodeInput.current.value.trim();
		if(isEmpty(codeNumber)) return false;
		const response = await fetch(`${apiUrl}/tracking/${codeNumber}`)
		const [trackingData] = await response.json()
		setTrackingOrder(trackingData);
		setTrackingState(JSON.parse(trackingData.states))
		
	}
	
	return (
		<div className="container mx-auto py-8">
			<Card className="card">
				<div className="grid grid-cols-12 gap-4 py-16">
					<div className="col-start-2 col-span-6">
						<h1 className="text-5xl">Ingresa tu código de seguimiento</h1>
						<div className="bar--blue ml__background--blue h-3 w-1/2 my-3"></div>
						<form>
							<Input label="Nº de Tracking" className="w-1/2 mb-3" ref={trackingCodeInput}/>
							<Button onClick={getTrackingOrder} className="rounded-md text-white px-5 py-2 ml__background--blue hover:bg-sky-600" type="button">
								Rastrear
							</Button>
						</form>
					</div>
					<div className="col-start-9 col-span-3 text-center">
						<img src={deliveryBox} alt="Delivery Box" className="inline-block" />
					</div>
				</div>
			</Card>

			{ trackingOrder &&
				<Card className="card">
					<div className="grid grid-cols-12 gap-4 py-16">
						<div className="col-start-2 col-span-3">
							<div className="box-info ml__background--blue p-5 rounded-xl text-white">
								<h2 className="text-2xl mb-3">Datos de Envío</h2>
								<div className="mb-3">
									<p className="text-lg">
										<strong>NOMBRES Y APELLIDOS</strong>
									</p>
									<p>{ `${trackingOrder.firstname} ${trackingOrder.lastname}` }</p>
								</div>
								{ trackingOrder.street &&
									<div className="mb-3">
										<p className="text-lg">
											<strong>DESTINO</strong>
										</p>
										<p>{ `${trackingOrder.street}, ${trackingOrder.district}, ${trackingOrder.province}, ${trackingOrder.region}, ${trackingOrder.country}.` }</p>
									</div>
								}
								<div className="mb-3">
									<p className="text-lg">
										<strong>Nº DE TRACKING</strong>
									</p>
									<p> { trackingOrder.code }</p>
								</div>
							</div>
						</div>
						<div className="col-start-6 col-span-6">
							<h2 className="text-4xl text-center mb-8">Tu mercadería se encuentra en:</h2>
							<div className="tracking_states relative">
								<Timeline />
								<State trackingState={trackingState} trackingOrder={trackingOrder}/>
								
							</div>
						</div>
					</div>
				</Card>
				// :
				// <Card className="card">
				// 	<div className="grid grid-cols-12 gap-4 py-16">
				// 		<div className="col-start-2 col-span-3">
				// 			<h2>El código de consulta no se encuentra en nuestra base de datos</h2>
				// 		</div>
				// 	</div>
				// </Card>	
			}
		</div>
	);
}

export default App;
